// extracted by mini-css-extract-plugin
export var container = "reportercomment-module--container--IgpZ-";
export var text = "reportercomment-module--text--1pzAn";
export var title = "reportercomment-module--title--THvL2";